"use strict";
export const initGsap = async (selector) => {
    const firstElement = document.querySelector(selector);
    if (!firstElement) return;

    let gsap, ScrollTrigger;
    
    try {
        // Dynamically import GSAP and ScrollTrigger
        const gsapModule = await import('gsap');
        const scrollTriggerModule = await import('gsap/ScrollTrigger');
        
        gsap = gsapModule.default || gsapModule.gsap;
        ScrollTrigger = scrollTriggerModule.default || scrollTriggerModule.ScrollTrigger;

        // Register ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);

        // Initialize hero staircase timeline
        await initHeroTimeline('.hero', gsap, ScrollTrigger);

        initAnimatedCircleImage('.image-text-columns__image');

        // Initialize particle morphing section
        initParticleMorphingSection('.particle-morph');

        // Initialize timeline section
        initTimelineSection('.timeline');

        // Initialize bubble diagram section
        initBubbleDiagramSection('.bubble-diagram');
    } catch (error) {
        console.error("Failed to load GSAP dynamically:", error);
        return;
    }

    async function initHeroTimeline(selector, gsap, ScrollTrigger) {
        const heroContainer = document.querySelector(selector);
        if (!heroContainer) return;

        try {
            // Import the hero timeline module
            const heroModule = await import('../modules/hero-timeline');
            
            // Initialize the hero timeline with GSAP and ScrollTrigger
            await heroModule.initHeroTimeline(selector, gsap, ScrollTrigger);
        } catch (error) {
            console.error("Failed to load Hero Timeline module:", error);
        }
    }

    async function initParticleMorphingSection(selector) {
        const particleSection = document.querySelector(selector);
        if (!particleSection) return;

        try {
            // Import the particle morphing module
            const particleModule = await import('../modules/particle-morphing');
            
            // Initialize the particle morphing with GSAP and ScrollTrigger
            await particleModule.initParticleMorphing(selector, gsap, ScrollTrigger);
        } catch (error) {
            console.error("Failed to load Particle Morphing module:", error);
        }
    }

    async function initAnimatedCircleImage(selector) {
        const circleImage = document.querySelector(selector);
        if (!circleImage) return;

        try {
            const circleImageModule = await import('../modules/animated-circle-image');
            
            circleImageModule.default(circleImage, gsap, ScrollTrigger, selector.replace('.', ''));
        } catch (error) {
            console.error("Failed to load Animated Circle Image module:", error);
        }
    }

    async function initTimelineSection(selector) {
        const timelineSection = document.querySelector(selector);
        if (!timelineSection) return;

        try {
            // Import the timeline GSAP module
            const timelineModule = await import('../modules/timeline');
            
            // Initialize the timeline with GSAP and ScrollTrigger
            timelineModule.default(timelineSection, gsap, ScrollTrigger);
        } catch (error) {
            console.error("Failed to load Timeline GSAP module:", error);
        }
    }

    async function initBubbleDiagramSection(selector) {
        const bubbleDiagramSection = document.querySelector(selector);
        if (!bubbleDiagramSection) return;

        try {
            // Import the bubble diagram GSAP module
            const bubbleDiagramModule = await import('../modules/bubble-diagram');
            
            // Initialize the bubble diagram with GSAP and ScrollTrigger
            bubbleDiagramModule.default(selector, gsap, ScrollTrigger);
        } catch (error) {
            console.error("Failed to load Bubble Diagram GSAP module:", error);
        }
    }
}